import {Api} from '../../../Api.js'

const RESOURCE = 'attribute'

export default {
    resource: RESOURCE,
    all(query) {
        return Api().get(this.resource + '/all' )
    },
    allForProducts(query) {
        return Api().get(this.resource + '/allforproducts' )
    },
    query(query) {
        return Api().get(this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.resource, data)
    },
    update(id, data) {
        return Api().put(this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.resource + '/' + id)
    },
    import(data) {
        return Api().post(this.resource + '/import', data)
    },
    addValue(data) {
        return Api().post(this.resource + '/addvalue', data)
    },
}


// WEBPACK FOOTER //
// ./src/modules/config/attribute/AttributeService.js